import { render, staticRenderFns } from "./LogInventory.vue?vue&type=template&id=756f0f84&"
import script from "./LogInventory.vue?vue&type=script&lang=js&"
export * from "./LogInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports